
import { MyOrganization } from "../components/my-organization";
import Units from "../pages/units";
import { USER_ROLES, MAIN_ROUTES_URLS } from "../constants/constants";
import { Messaging } from "../components/Messaging";
import { GeneratePdfDocument } from "../components/generatePdfDocument";
import TenantDashboard from "../tenantComponent/components/tenantDashboard";
import TenantServiceRequest from "../tenantComponent/components/serviceRequest";
import Transactions from "../tenantComponent/components/transactions";
import Chat from "../tenantComponent/components/chat";
import LeaseDetails from "../tenantComponent/components/leaseDetails";
import PaymentMethods from "../tenantComponent/components/paymentMethods";
import { MyProfile } from "../tenantComponent/components/myProfile";
import { GenerateEmail } from "../components/generateEmail";
import Transaction from "../newComponents/transactions";
import { OrganizationAccounts } from "../components/organizationAccounts";
import { PlatformSettings } from "../components/platform-settings";
import NewDashboard from "../newDashboard";
import Contractors from "../pages/contractors";
import Payments from "../pages/payments";
import Tenants from "../pages/tenants";
import ServiceRequest from "../pages/service-request";
import Properties from "../pages/properties";
import "../newComponents/listings/listing-card.css"

export const routeList = {
  [USER_ROLES[1]]: [
    { id: "1", path: MAIN_ROUTES_URLS.HOME, element: <NewDashboard/> },
    { id: "2", path: MAIN_ROUTES_URLS.UNITS, element: <Units /> },
    { id: "3", path: MAIN_ROUTES_URLS.PROPERTIES, element: <Properties /> },
    { id: "4", path: MAIN_ROUTES_URLS.TENANTS, element: <Tenants /> },
    { id: "5", path: MAIN_ROUTES_URLS.SERVICE_REQUESTS, element: <ServiceRequest />, },
    { id: "7", path: MAIN_ROUTES_URLS.CONTRACTORS, element: <Contractors /> },
    { id: "8", path: MAIN_ROUTES_URLS.ORGANIZATION, element: <MyOrganization />, },
    { id: "9", path: MAIN_ROUTES_URLS.MESSAGING, element: <Messaging /> },
    { id: "11", path: MAIN_ROUTES_URLS.ORGANIZATION_ACCOUNTS, element: <OrganizationAccounts /> },
    { id: "12", path: MAIN_ROUTES_URLS.GENERATE_PDF_DOCUMENT, element: <GeneratePdfDocument /> },
    { id: "12", path: MAIN_ROUTES_URLS.GENERATE_EMAIL, element: <GenerateEmail /> },
    { id: "13", path: MAIN_ROUTES_URLS.PAYMENT, element: <Payments /> },
    { id: "14", path: MAIN_ROUTES_URLS.TRANSACTION, element: <Transaction /> },
    { id: "15", path: MAIN_ROUTES_URLS.PLATFORMSETTINGS, element: <PlatformSettings />, },
  ],


  [USER_ROLES[4]]: [
    { id: "1", path: MAIN_ROUTES_URLS.HOME, element: <TenantDashboard /> },
    { id: "2", path: MAIN_ROUTES_URLS.TENANT_SERVICE_REQUESTS, element: <TenantServiceRequest /> },
    { id: "3", path: MAIN_ROUTES_URLS.TRANSACTIONS, element: <Transactions /> },
    { id: "4", path: MAIN_ROUTES_URLS.CHAT, element: <Chat /> },
    { id: "5", path: MAIN_ROUTES_URLS.LEASE_DETAILS, element: <LeaseDetails /> },
    { id: "6", path: MAIN_ROUTES_URLS.PAYMENT_METHODS, element: <PaymentMethods /> },
    { id: "7", path: MAIN_ROUTES_URLS.MY_PROFILE, element: <MyProfile /> }
  ],
};
